export default "__VITE_PUBLIC_ASSET__59657934__"